// src/pages/OtimizacaoFinanceira.jsx
import React from 'react';
import { Link } from 'react-router-dom';

import './OtimizacaoFinanceira.css';

const OtimizacaoFinanceira = () => {
  return (
    <main className="page-finance">

      {/* Seção 1: Visão Financeira Consolidada */}
      <section className="finance-vision-section">
        <div className="page-content">
          <h1 className="section-title">
            Vá Além das Cobranças, Negocie Melhor
          </h1>
          <p className="section-text">
            Visualize a <strong>JORNADA FINANCEIRA DO ALUNO</strong> em uma tela de análise inteligente,
            com todas as suas mensalidades, histórico de pagamentos e situações de parcelas.
            Combine a análise financeira ao perfil pedagógico para decisões mais assertivas.
          </p>
          <Link to="/contato" className="btn btn-primary">Entre em Contato</Link>
        </div>
      </section>
      {/* /Visão Financeira Consolidada */}

      {/* Seção 2: Atendimento ao Aluno Inadimplente */}
      <section className="financial-attendance-section">
        <div className="section-content">
          <div className="page-content">
            <div className="section-flex-item-left">
              <div className="financial-attendance-diagram"></div>
            </div>
            <div className="section-flex-item-right">
              <h2 className="section-title">Eficiência nas Ações de Negociação e Atendimento</h2>
              <p className="section-text">
                A inadimplência eleva o risco de evasão. Por isso, com a CODI, você não apenas detecta atrasos
                rapidamente, mas também automatiza alertas de cobrança, envia negociações personalizadas
                e acompanha as respostas em um só lugar.
              </p>
              <ul className="financial-features-list">
                <li>
                  <strong>Automação de Mensagens:</strong> Dispare lembretes automáticos e avisos de cobrança de forma proativa.
                </li>
                <li>
                  <strong>Histórico de Negociações:</strong> Veja rapidamente se o aluno costuma atrasar ou se é um caso pontual.
                </li>
                <li>
                  <strong>Score de Adimplência:</strong> Avalie a viabilidade de renegociar com base em um indicador avançado.
                </li>
                <li>
                  <strong>Dados Atualizados:</strong> Importação automática diária de dados financeiros de mensalidades, descontos e pagamentos.
                </li>
                <li>
                  <strong>Integração com o Funil:</strong> Alunos inadimplentes podem receber atendimento personalizado,
                  unindo a visão financeira ao acompanhamento pedagógico.
                </li>
              </ul>
              <Link to="/funil" className="btn btn-primary">Conheça o Funil da Permanência</Link>
            </div>
          </div>
        </div>
      </section>
      {/* /Atendimento ao Aluno Inadimplente */}

      {/* Seção 3: Histórico Financeiro do Aluno */}
      <section className="planning-section">
        <div className="page-content">
          <h1 className="section-title">Planeje Resultados Melhores</h1>
          <p className="section-text">Com a CODI, o setor financeiro tem relatórios gerenciais avançados, ideais para <strong>planejamento estratégico</strong>.</p>
          <div className="planning-features">
            <div className="planning-feature">Receita bruta</div>
            <div className="planning-feature">Receita líquida</div>
            <div className="planning-feature">Ticket médio</div>
            <div className="planning-feature">Desconto médio</div>
            <div className="planning-feature">FIES</div>
            <div className="planning-feature">PROUNI</div>
            <div className="planning-feature">Inadimplência em 30, 60 e 90 dias</div>
            <div className="planning-feature">Fluxo de caixa</div>
            <div className="planning-feature">...e muito mais!</div>
          </div>
          <p className="section-text">Tudo isso segmentado <strong>por curso, polo ou unidade</strong>.</p>
          <Link to="/contato" className="btn btn-primary">Agende uma demonstração</Link>
        </div>
      </section>
      {/* /Histórico Financeiro do Aluno */}

    </main>
  );
};

export default OtimizacaoFinanceira;
